import React, { useState, useContext } from "react";
import { SurveyRespondentDataContext } from "../../providers/survey-respondent-data";

const getInitialMessage = (requiresPassword, respondentIdType) => {
  if (requiresPassword) {
    return "El siguiente formulario requiere que inicies sesión con tu cuenta institucional.";
  }

  const initialMessage =
    "Para una mejor experiencia con este formulario solicitamos que pueda ingresar su ";

  switch (respondentIdType) {
    case "email":
      return initialMessage + "correo electrónico.";
    case "rut":
      return initialMessage + "rut.";
    case "ulagos_email_alumno":
      return initialMessage + "correo institucional ULAGOS.";
    default:
      return "";
  }
};

const getInputType = (respondentIdType) => {
  switch (respondentIdType) {
    case "email":
      return "email";
    case "rut":
      return "tel";
    case "ulagos_email_alumno":
    default:
      return "text";
  }
};

const getInputPlaceholder = (respondentIdType) => {
  switch (respondentIdType) {
    case "rut":
      return "Tu número de RUT";
    case "email":
      return "Tu dirección de correo electrónico";
    case "ulagos_email_alumno":
      return "Tu nombre de usuario institucional";
    default:
      return "";
  }
};

const IdentificationModalForm = ({ handleSubmit, isValidating, invalidInputComponent }) => {
  const { respondentIdType, requiresPassword } = useContext(SurveyRespondentDataContext);
  const [respondentId, setRespondentId] = useState("");
  const [password, setPassword] = useState("");

  const initialMessage = getInitialMessage(requiresPassword, respondentIdType);
  const inputType = getInputType(respondentIdType);
  const inputPlaceholder = getInputPlaceholder(respondentIdType);

  const otherInputProps =
    respondentIdType === "rut"
      ? {
          maxLength: 8,
        }
      : {};

  const onRespondentIdChange = (event) =>
    setRespondentId(
      respondentIdType === "rut" ? event.target.value.replace(/[^0-9]/g, "") : event.target.value
    );
  const onPasswordChange = (event) => setPassword(event.target.value);

  return (
    <form onSubmit={handleSubmit}>
      <div className="modal-body pb-0">
        <h5 className="mb-2 text-primary text-center">{initialMessage}</h5>
        {respondentIdType === "rut" && (
          <div className="card bg-warning mb-2 p-2 border-0">
            <h5 className="text-black font-weight-bold m-auto">
              RUT sin puntos y sin dígito verificador.
            </h5>
            <h5 className="text-black font-weight-bold m-auto">Ej: 12345678</h5>
          </div>
        )}
        {respondentIdType === "ulagos_email_alumno" && (
          <span
            className="position-absolute input-group-text font-weight-bold text-white border-bottom-left-0 border-top-left-0 bg-primary"
            style={{ right: "15px" }}
          >
            @alumnos.ulagos.cl
          </span>
        )}
        <input
          id={`form-modal-input-${inputType}`}
          className="form-control border-primary mb-2"
          required
          type={inputType}
          value={respondentId}
          placeholder={inputPlaceholder}
	        autoCapitalize="off"
          onInput={onRespondentIdChange}
          {...otherInputProps}
          aria-describedby={inputType === "ulagos_email_alumno"}
        />
        {requiresPassword && (
          <input
            id="form-modal-input-password"
            className="form-control border-primary mb-2"
            required
            type="password"
            value={password}
            placeholder={"Tu contraseña"}
            onInput={onPasswordChange}
            autoComplete="off"
          />
        )}
        {invalidInputComponent}
      </div>
      <div className="d-flex justify-content-end px-3 pb-3">
        {isValidating ? (
          <div className="d-flex align-items-center">
            <span className="text-primary mr-2">Procesando</span>
            <div className="loading-icon small" />
          </div>
        ) : (
          <button type="submit" className="btn btn-custom btn-primary">
            <i className={`fas ${requiresPassword ? "fa-arrow-right" : "fa-check"} mr-2`} />
            {requiresPassword ? "Iniciar sesión" : "Confirmar"}
          </button>
        )}
      </div>
    </form>
  );
};

export default IdentificationModalForm;
